// extracted by mini-css-extract-plugin
export default {"loading-container":"PageLoader_loading-container__9yiaR","loading-icon":"PageLoader_loading-icon__sKEfz"};